import { render, staticRenderFns } from "./logincheck.vue?vue&type=template&id=51647433"
import script from "./logincheck.vue?vue&type=script&lang=js"
export * from "./logincheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports